/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseUserSearch
 */
export interface ResponseUserSearch {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseUserSearch
     */
    result: ResponseResult;
    /**
     * 
     * @type {User}
     * @memberof ResponseUserSearch
     */
    data: User;
}

/**
 * Check if a given object implements the ResponseUserSearch interface.
 */
export function instanceOfResponseUserSearch(value: object): value is ResponseUserSearch {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseUserSearchFromJSON(json: any): ResponseUserSearch {
    return ResponseUserSearchFromJSONTyped(json, false);
}

export function ResponseUserSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserSearch {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': UserFromJSON(json['data']),
    };
}

export function ResponseUserSearchToJSON(json: any): ResponseUserSearch {
    return ResponseUserSearchToJSONTyped(json, false);
}

export function ResponseUserSearchToJSONTyped(value?: ResponseUserSearch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': UserToJSON(value['data']),
    };
}

